module.exports = __webpack_public_path__ + "img/myjl@2x.5d5d78ee.png";